import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import './Clubs.css';

const Clubs = () => {


    return (
        <div className="container ">
            <h1 id='head' >Our Clubs</h1>
            <div className="item1" data-aos="fade-left">
                <div className="clubInfo">
                    <div className="clubName">
                        <h1>Software Club</h1>
                    </div>
                    <div className="clubLogo">
                        <img className='clubLogo' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQyjCy4Qb9rCv9bVIxeAbFsZJYrFCdZCDo1RqiwGvrAw&s" alt="" />
                    </div>
                    <div className="clubDescription">
                        <p>
                            The Software Club vision is to collaborate, plan and organize trainings, bootcamps, workshops and other coding competitions similar to Deerthon with aim to provide students a competitive environment to build up a minimum viable product using their technical and non-technical skills.                        </p>
                    </div>
                    <footer>
                        <div className={`clubSocialMedia `}>
                            <a href='https://www.facebook.com/dwit.softwareclub'><FontAwesomeIcon icon={faFacebook} /></a>
                            <a href="https://twitter.com/deerwalkcollege">    <FontAwesomeIcon icon={faTwitter} /></a>
                            <a href="https://www.instagram.com/dwit_software_club/"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://www.linkedin.com/in/dwit-software-club-6369ba245/"><FontAwesomeIcon icon={faLinkedin} /></a>
                        </div>
                    </footer>
                </div>
            </div>
            <div className="item2" data-aos="fade-right">
                <div className="clubInfo">
                    <div className="clubName">
                        <h1>DWIT Hiking Club</h1>
                    </div>
                    <div className="clubLogo">
                        <img className='clubLogo' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQyjCy4Qb9rCv9bVIxeAbFsZJYrFCdZCDo1RqiwGvrAw&s" alt="" />
                    </div>
                    <div className="clubDescription">
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tempora alias fuga ad maxime veniam, qui blanditiis quis atque nulla est quibusdam accusantium deleniti labore cupiditate hic quam praesentium optio officia.
                        </p>
                    </div>
                    <footer>
                        <div className={`clubSocialMedia `}>
                            <a href='https://www.facebook.com/dwit.softwareclub'><FontAwesomeIcon icon={faFacebook} /></a>
                            <a href="https://twitter.com/deerwalkcollege">    <FontAwesomeIcon icon={faTwitter} /></a>
                            <a href="https://www.instagram.com/dwit_software_club/"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://www.linkedin.com/in/dwit-software-club-6369ba245/"><FontAwesomeIcon icon={faLinkedin} /></a>
                        </div>
                    </footer>
                </div>
            </div>
            <div className="item3" data-aos="fade-left">
                <div className="clubInfo">
                    <div className="clubName">
                        <h1>DWIT Sports Club</h1>
                    </div>
                    <div className="clubLogo">
                        <img className='clubLogo' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQyjCy4Qb9rCv9bVIxeAbFsZJYrFCdZCDo1RqiwGvrAw&s" alt="" />
                    </div>
                    <div className="clubDescription">
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tempora alias fuga ad maxime veniam, qui blanditiis quis atque nulla est quibusdam accusantium deleniti labore cupiditate hic quam praesentium optio officia.
                        </p>
                    </div>
                    <footer>
                        <div className={`clubSocialMedia `}>
                            <a href='https://www.facebook.com/dwit.softwareclub'><FontAwesomeIcon icon={faFacebook} /></a>
                            <a href="https://twitter.com/deerwalkcollege">    <FontAwesomeIcon icon={faTwitter} /></a>
                            <a href="https://www.instagram.com/dwit_software_club/"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://www.linkedin.com/in/dwit-software-club-6369ba245/"><FontAwesomeIcon icon={faLinkedin} /></a>
                        </div>
                    </footer>
                </div>
            </div>
            <div className="item4" data-aos="fade-right">
                <div className="clubInfo">
                    <div className="clubName">
                        <h1>DWIT News and Media Club</h1>
                    </div>
                    <div className="clubLogo">
                        <img className='clubLogo' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQyjCy4Qb9rCv9bVIxeAbFsZJYrFCdZCDo1RqiwGvrAw&s" alt="" />
                    </div>
                    <div className="clubDescription">
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tempora alias fuga ad maxime veniam, qui blanditiis quis atque nulla est quibusdam accusantium deleniti labore cupiditate hic quam praesentium optio officia.
                        </p>
                    </div>
                    <footer>
                        <div className={`clubSocialMedia `}>
                            <a href='https://www.facebook.com/dwit.softwareclub'><FontAwesomeIcon icon={faFacebook} /></a>
                            <a href="https://twitter.com/deerwalkcollege">    <FontAwesomeIcon icon={faTwitter} /></a>
                            <a href="https://www.instagram.com/dwit_software_club/"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://www.linkedin.com/in/dwit-software-club-6369ba245/"><FontAwesomeIcon icon={faLinkedin} /></a>
                        </div>
                    </footer>
                </div>
            </div>
            <div className="item5" data-aos="fade-left"> <div className="clubInfo">
                <div className="clubName">
                    <h1>DWIT Social Service Club</h1>
                </div>
                <div className="clubLogo">
                    <img className='clubLogo' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQyjCy4Qb9rCv9bVIxeAbFsZJYrFCdZCDo1RqiwGvrAw&s" alt="" />
                </div>
                <div className="clubDescription">
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tempora alias fuga ad maxime veniam, qui blanditiis quis atque nulla est quibusdam accusantium deleniti labore cupiditate hic quam praesentium optio officia.
                    </p>
                </div>
                <footer>
                        <div className={`clubSocialMedia `}>
                            <a href='https://www.facebook.com/dwit.softwareclub'><FontAwesomeIcon icon={faFacebook} /></a>
                            <a href="https://twitter.com/deerwalkcollege">    <FontAwesomeIcon icon={faTwitter} /></a>
                            <a href="https://www.instagram.com/dwit_software_club/"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://www.linkedin.com/in/dwit-software-club-6369ba245/"><FontAwesomeIcon icon={faLinkedin} /></a>
                        </div>
                    </footer>
            </div>
            </div>
            <div className="item6" data-aos="fade-right">
                <div className="clubInfo">
                    <div className="clubName">
                        <h1>DWIT Deer Express Club</h1>
                    </div>
                    <div className="clubLogo">
                        <img className='clubLogo' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQyjCy4Qb9rCv9bVIxeAbFsZJYrFCdZCDo1RqiwGvrAw&s" alt="" />
                    </div>
                    <div className="clubDescription">
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tempora alias fuga ad maxime veniam, qui blanditiis quis atque nulla est quibusdam accusantium deleniti labore cupiditate hic quam praesentium optio officia.
                        </p>
                    </div>
                    <footer>
                        <div className={`clubSocialMedia `}>
                            <a href='https://www.facebook.com/dwit.softwareclub'><FontAwesomeIcon icon={faFacebook} /></a>
                            <a href="https://twitter.com/deerwalkcollege">    <FontAwesomeIcon icon={faTwitter} /></a>
                            <a href="https://www.instagram.com/dwit_software_club/"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://www.linkedin.com/in/dwit-software-club-6369ba245/"><FontAwesomeIcon icon={faLinkedin} /></a>
                        </div>
                    </footer>
                </div>
            </div>
            <div className="item7" data-aos="fade-left">
                <div className="clubInfo">
                    <div className="clubName">
                        <h1>DWIT Music Club</h1>
                    </div>
                    <div className="clubLogo">
                        <img className='clubLogo' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQyjCy4Qb9rCv9bVIxeAbFsZJYrFCdZCDo1RqiwGvrAw&s" alt="" />
                    </div>
                    <div className="clubDescription">
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tempora alias fuga ad maxime veniam, qui blanditiis quis atque nulla est quibusdam accusantium deleniti labore cupiditate hic quam praesentium optio officia.
                        </p>
                    </div>
                    <footer>
                        <div className={`clubSocialMedia `}>
                            <a href='https://www.facebook.com/dwit.softwareclub'><FontAwesomeIcon icon={faFacebook} /></a>
                            <a href="https://twitter.com/deerwalkcollege">    <FontAwesomeIcon icon={faTwitter} /></a>
                            <a href="https://www.instagram.com/dwit_software_club/"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://www.linkedin.com/in/dwit-software-club-6369ba245/"><FontAwesomeIcon icon={faLinkedin} /></a>
                        </div>
                    </footer>
                </div>
            </div>
            <div className="item8" data-aos="fade-right">
                <div className="clubInfo">
                    <div className="clubName">
                        <h1>DWIT Artistas Club</h1>
                    </div>
                    <div className="clubLogo">
                        <img className='clubLogo' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQyjCy4Qb9rCv9bVIxeAbFsZJYrFCdZCDo1RqiwGvrAw&s" alt="" />
                    </div>
                    <div className="clubDescription">
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tempora alias fuga ad maxime veniam, qui blanditiis quis atque nulla est quibusdam accusantium deleniti labore cupiditate hic quam praesentium optio officia.
                        </p>
                    </div>
                    <footer>
                        <div className={`clubSocialMedia `}>
                            <a href='https://www.facebook.com/dwit.softwareclub'><FontAwesomeIcon icon={faFacebook} /></a>
                            <a href="https://twitter.com/deerwalkcollege">    <FontAwesomeIcon icon={faTwitter} /></a>
                            <a href="https://www.instagram.com/dwit_software_club/"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://www.linkedin.com/in/dwit-software-club-6369ba245/"><FontAwesomeIcon icon={faLinkedin} /></a>
                        </div>
                    </footer>
                </div>
            </div>
            <div className="item9" data-aos="fade-left">
                <div className="clubInfo">
                    <div className="clubName">
                        <h1>DWIT Literature Club</h1>
                    </div>
                    <div className="clubLogo">
                        <img className='clubLogo' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQyjCy4Qb9rCv9bVIxeAbFsZJYrFCdZCDo1RqiwGvrAw&s" alt="" />
                    </div>
                    <div className="clubDescription">
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tempora alias fuga ad maxime veniam, qui blanditiis quis atque nulla est quibusdam accusantium deleniti labore cupiditate hic quam praesentium optio officia.
                        </p>
                    </div>
                    <footer>
                        <div className={`clubSocialMedia `}>
                            <a href='https://www.facebook.com/dwit.softwareclub'><FontAwesomeIcon icon={faFacebook} /></a>
                            <a href="https://twitter.com/deerwalkcollege">    <FontAwesomeIcon icon={faTwitter} /></a>
                            <a href="https://www.instagram.com/dwit_software_club/"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://www.linkedin.com/in/dwit-software-club-6369ba245/"><FontAwesomeIcon icon={faLinkedin} /></a>
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    );
};

export default Clubs;
